module.exports = __webpack_public_path__ + "img/party.9ff39edd.png";